import React, { createContext, useMemo, useContext } from "react";
import Axios from "axios";
import { URL } from "./../context/config";
const AxiosContext = createContext();

export function AxiosProvider({ children }) {
	const axios = useMemo(() => {
		const axios = Axios.create({
			headers: {
				"Content-Type": "application/json",
			},
		});

		axios.interceptors.request.use((config) => {
			// Read token for anywhere, in this case directly from localStorage
			config.baseURL = URL;

			const token = localStorage.getItem("somity_administration_token");
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		});

		return axios;
	}, []);

	return (
		<AxiosContext.Provider value={axios}>{children}</AxiosContext.Provider>
	);
}

export function useAxios() {
	return useContext(AxiosContext);
}

export function useBaseUrl(){
	return {
		URL
	};
}